export default "__VITE_ASSET__B5zko6qr__"